/**
 * @file
 * Contains helper functions for anonymous favorite job functionality.
 */

/**
 * Get list of jobs marked as favorite.
 * Each key of the object is job id, and value is job data.
 *
 * @returns {Object}
 */
export const getFavorites = () => {
  const defaultFavJobs = window.localStorage.getItem('favJobs');
  return defaultFavJobs ? JSON.parse(defaultFavJobs) : [];
};

/**
 * Get number of users favorite jobs.
 *
 * @returns {number}
 */
export const getQuantity = () => Object.keys(getFavorites()).length;

/**
 * Mark job as favorite.
 *
 * @param {number} jobId
 *   The job id.
 * @param {Object} jobData
 *   The job data
 *
 * @returns {Object}
 *   Updated list of favorite jobs.
 */
export const markAsFavorite = (jobId, jobData) => {
  let favorites = getFavorites();
  favorites = { ...favorites, ...{ [jobId]: jobData } };
  window.localStorage.setItem('favJobs', JSON.stringify(favorites));
  return favorites;
};

/**
 * Delete job from favorites.
 *
 * @param {number} jobId
 *   The job id.
 *
 * @returns {Object}
 *   Updated list of favorite jobs.
 */
export const deleteFromFavorite = (jobId) => {
  const favorites = getFavorites();
  delete favorites[jobId];
  window.localStorage.setItem('favJobs', JSON.stringify(favorites));
  return favorites;
};
